import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ShieldCheckFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zm-2 16-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9z"
      fill="currentColor"
    />
  </svg>
);

ShieldCheckFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ShieldCheckFilledIcon);
